import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'displayValue', pure: true })
export class DisplayValuePipe implements PipeTransform {
    transform(fan: { email?: string | null; phone?: string | null } | null | undefined): string | null {
        if (!fan) return null;
        const email = (fan.email || '').trim();
        const phone = (fan.phone || '').trim();
        if (email && !/@ioncourt\.com$/i.test(email)) return email;
        return phone || null;
    }
}